module.exports = __webpack_public_path__ + "img/map-3-f@2x.1fd00fe4.png";